import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      d: "M14.7 5.7 12 3 9.3 5.7M9.3 18.3 12 21l2.7-2.7M12 21V3M18.3 14.7 21 12l-2.7-2.7M5.7 9.3 3 12l2.7 2.7M3 12h18"
    }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }